(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["google-reviews-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('google-reviews')) {
    customElements.define(
      'google-reviews',
      class GoogleReviews extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-google-reviews-track]');
          this.previousButton = this.querySelector('[data-google-reviews-prev]');
          this.nextButton = this.querySelector('[data-google-reviews-next]');
          this.showMoreLabel = this.dataset.showMoreLabel;
          this.showLessLabel = this.dataset.showLessLabel;

          if (!this.track || !this.previousButton || !this.nextButton) return;

          this.previousButton.addEventListener('click', () => this.scroll(-1));
          this.nextButton.addEventListener('click', () => this.scroll(1));
          this.setupReviewText();
          requestAnimationFrame(() => this.setupReviewText());
          if (document.fonts) {
            document.fonts.ready.then(() => this.setupReviewText());
          }
          window.addEventListener('resize', () => this.setupReviewText());
        }

        scroll(direction) {
          const card = this.track.querySelector('.google-review-card');
          const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const distance = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;

          this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
        }

        setupReviewText() {
          this.querySelectorAll('.google-review-card').forEach((card) => {
            const text = card.querySelector('[data-google-review-text]');
            const toggle = card.querySelector('[data-google-review-toggle]');
            const toggleLabel = card.querySelector('[data-google-review-toggle-label]');

            if (!text || !toggle || !toggleLabel) return;

            card.classList.remove('is-expanded');
            toggle.setAttribute('aria-expanded', 'false');
            toggleLabel.textContent = this.showMoreLabel;
            toggle.hidden = !this.isReviewClipped(text);

            toggle.onclick = () => {
              const isExpanded = card.classList.toggle('is-expanded');

              toggle.setAttribute('aria-expanded', String(isExpanded));
              toggleLabel.textContent = isExpanded ? this.showLessLabel : this.showMoreLabel;
            };
          });
        }

        isReviewClipped(text) {
          return text.scrollHeight > text.clientHeight + 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["native-gift-signup-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initGiftPopup = () => {
    const root = document.getElementById('NativeGiftSignupPopup');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const storageKey = 'rvGiftSignupPopup';
    const visitsKey = 'rvGiftSignupPageVisits';
    const delayMs = Number(root.dataset.delaySeconds || 180) * 1000;
    const cookieDays = Number(root.dataset.cookieDays || 7);
    const visitThreshold = Number(root.dataset.pageVisits || 6);
    const giftVariantId = root.dataset.giftVariantId;
    const overlay = root.querySelector('.rv-gift-popup__overlay');
    const dialog = root.querySelector('.rv-gift-popup__dialog');
    const shell = root.querySelector('.rv-gift-popup__shell');
    const formStep = root.querySelector('.rv-gift-popup__form-step');
    const successStep = root.querySelector('.rv-gift-popup__success-step');
    const form = root.querySelector('.rv-gift-popup__form');
    const iframe = root.querySelector('.rv-gift-popup__target');
    const submit = root.querySelector('.rv-gift-popup__submit');
    const teaser = root.querySelector('.rv-gift-popup__teaser');
    const teaserClose = root.querySelector('.rv-gift-popup__teaser-close');
    const closeButtons = root.querySelectorAll('.rv-gift-popup__close, .rv-gift-popup__continue');
    let opened = false;
    let pendingSignup = false;
    let submitAttempt = 0;
    let delayTimer;
    let closeTimer;
    const isTouchDevice = window.matchMedia('(pointer: coarse)').matches || window.innerWidth <= 749;
    const errorMessage = root.querySelector('.rv-gift-popup__error');
    let mobileExitArmed = false;
    let lastScrollY = window.scrollY;
    let lastScrollAt = Date.now();

    const now = () => Date.now();
    const getState = () => {
      try {
        return JSON.parse(localStorage.getItem(storageKey) || '{}');
      } catch (error) {
        return {};
      }
    };
    const setState = (state) => {
      try {
        localStorage.setItem(storageKey, JSON.stringify(state));
      } catch (error) {}
    };
    const suppressPopupUntil = () => {
      setState({ ...getState(), popupSuppressedUntil: now() + cookieDays * 24 * 60 * 60 * 1000 });
    };
    const suppressTeaserUntil = () => {
      setState({ ...getState(), teaserSuppressedUntil: now() + cookieDays * 24 * 60 * 60 * 1000 });
    };
    const isPopupSuppressed = () => {
      const state = getState();
      return Number(state.popupSuppressedUntil || 0) > now();
    };
    const isTeaserSuppressed = () => {
      const state = getState();
      return Number(state.teaserSuppressedUntil || 0) > now();
    };
    const incrementVisits = () => {
      try {
        const current = Number(sessionStorage.getItem(visitsKey) || '0') + 1;
        sessionStorage.setItem(visitsKey, String(current));
        return current;
      } catch (error) {
        return 1;
      }
    };

    const showTeaser = () => {
      if (isTeaserSuppressed()) return;
      window.requestAnimationFrame(() => {
        teaser.classList.add('is-visible');
      });
    };
    const hideTeaser = () => teaser.classList.remove('is-visible');

    const openPopup = ({ ignoreSuppression = false } = {}) => {
      if (opened || (!ignoreSuppression && isPopupSuppressed())) return;
      clearTimeout(closeTimer);
      opened = true;
      hideTeaser();
      overlay.hidden = false;
      dialog.hidden = false;
      window.requestAnimationFrame(() => {
        overlay.classList.add('is-open');
        dialog.classList.add('is-open');
      });
      document.body.classList.add('rv-gift-popup-lock');
      if (!isTouchDevice) {
        root.querySelector('.rv-gift-popup__input')?.focus({ preventScroll: true });
      }
    };

    const closePopup = ({ suppress = true } = {}) => {
      if (!opened && dialog.hidden) return;
      opened = false;
      overlay.classList.remove('is-open');
      dialog.classList.remove('is-open');
      document.body.classList.remove('rv-gift-popup-lock');
      if (suppress) {
        suppressPopupUntil();
      }
      closeTimer = setTimeout(() => {
        overlay.hidden = true;
        dialog.hidden = true;
        showTeaser();
      }, 320);
    };

    const showSuccess = () => {
      formStep.hidden = true;
      successStep.hidden = false;
      shell.dataset.step = 'success';
    };

    const addGiftToCart = async () => {
      if (!giftVariantId) return false;
      try {
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: giftVariantId, quantity: 1 })
        });
        const item = await addResponse.json();
        if (!addResponse.ok) throw new Error(item.description || 'Add failed');
        if (item.quantity > 1) {
          const changeResponse = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: giftVariantId, quantity: 1 })
          });
          if (!changeResponse.ok) {
            const error = await changeResponse.json();
            throw new Error(error.description || 'Quantity update failed');
          }
        }
        document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
        return true;
      } catch (error) {
        console.error('Cart Operation Error:', error.message);
        return false;
      }
    };

    const runGiftSignup = ({ submitButton, errorTarget, busyText, retryText }) => {
      const attempt = ++submitAttempt;
      pendingSignup = true;
      if (errorTarget) errorTarget.hidden = true;
      submitButton?.setAttribute('aria-busy', 'true');
      if (submitButton) submitButton.disabled = true;
      if (submitButton) submitButton.textContent = busyText;
      addGiftToCart().then((giftAdded) => {
        if (attempt !== submitAttempt) return;
        pendingSignup = false;
        submitButton?.removeAttribute('aria-busy');
        if (!giftAdded) {
          if (submitButton) submitButton.disabled = false;
          if (submitButton) submitButton.textContent = retryText;
          if (errorTarget) errorTarget.hidden = false;
          return;
        }
        if (submitButton) {
          submitButton.textContent = 'Gift Added';
        }
        suppressPopupUntil();
        suppressTeaserUntil();
        openPopup({ ignoreSuppression: true });
        showSuccess();
      });
    };

    form?.addEventListener('submit', () => {
      runGiftSignup({
        submitButton: submit,
        errorTarget: errorMessage,
        busyText: 'Claiming...',
        retryText: 'Try again'
      });
    });

    document.querySelectorAll('[data-rv-gift-newsletter-form]').forEach((emailInput) => {
      const footerForm = emailInput.form;
      if (!footerForm || footerForm.dataset.rvGiftSignupBound === 'true') return;
      footerForm.dataset.rvGiftSignupBound = 'true';
      footerForm.addEventListener('submit', () => {
        runGiftSignup({
          submitButton: footerForm.querySelector('button[type="submit"]'),
          busyText: 'Processing…',
          retryText: 'Try again'
        });
      });
    });

    iframe?.addEventListener('load', () => {
      if (!pendingSignup) return;
      pendingSignup = false;
    });

    closeButtons.forEach((button) => button.addEventListener('click', () => closePopup()));
    overlay.addEventListener('click', () => closePopup());
    teaser.addEventListener('click', (event) => {
      if (event.target === teaserClose) return;
      openPopup({ ignoreSuppression: true });
    });
    teaser.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      openPopup({ ignoreSuppression: true });
    });
    teaserClose.addEventListener('click', (event) => {
      event.stopPropagation();
      suppressTeaserUntil();
      hideTeaser();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && opened) closePopup();
    });
    document.addEventListener('mouseleave', (event) => {
      if (event.clientY <= 0) openPopup();
    });

    if (isTouchDevice) {
      window.setTimeout(() => {
        mobileExitArmed = true;
      }, 15000);
      window.addEventListener('scroll', () => {
        const currentTime = Date.now();
        const upwardDistance = lastScrollY - window.scrollY;
        const elapsed = currentTime - lastScrollAt;
        if (window.scrollY > 240) mobileExitArmed = true;
        if (mobileExitArmed && upwardDistance > 120 && elapsed < 700 && window.scrollY < 160) {
          openPopup();
          mobileExitArmed = false;
        }
        lastScrollY = window.scrollY;
        lastScrollAt = currentTime;
      }, { passive: true });
    }

    if (isPopupSuppressed()) {
      showTeaser();
      return;
    }
    const visits = incrementVisits();
    if (visits >= visitThreshold) openPopup();
    delayTimer = setTimeout(openPopup, delayMs);
    window.addEventListener('pagehide', () => clearTimeout(delayTimer), { once: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initGiftPopup, { once: true });
    } else {
      initGiftPopup();
    }
    document.addEventListener('shopify:section:load', initGiftPopup);
  })();

  } catch(e) { console.error(e); }
})();
})();
